
/** Converts array of strings to option. Option is object with value and text. 
 * @param {String[]} strings - Array of strings
 * @param {Function} labelCallback - Option text builder
 * @param {string} defaultLabel - Label of default option
 * @returns {Array.<{value:String, text:String}>} Array of options
*/
 export function convertStringsToOptions(strings, labelCallback, defaultLabel) {
    const options = Array.isArray(strings)
        ? strings.map(s => ({ value: s, text: labelCallback(s) }))
        : [];

    options.unshift({ value: null, text: defaultLabel });

    return options;
}